// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1RzTC","item":"PaymentsMobile_item__2NhX4","label":"PaymentsMobile_label__3kbMl","amount":"PaymentsMobile_amount__28E0s"};